// Where a PinGolf screen sends you "back" to, and who can see the raw Events list.
//
// The events list is an organizer tool: members reach a league night through the League
// screen's Next Event card, and PinGolfBottomNav only shows the Events tab to league
// managers. A back link pointing at /pingolf for a member therefore drops them on a page
// that is not in their nav at all, with no way back to where they came from - so the
// destination has to follow the same predicate the tab does.
export const canManagePingolfLeague = (user) => (
  user?.role === 'admin' || (user?.featureRoles || []).includes('penthouse_league')
);

export const LEAGUE_PATH = '/pingolf-season';
export const EVENTS_PATH = '/pingolf';

// League is the default landing spot; only someone who actually has the Events tab goes
// back to Events.
export const pingolfBackTarget = (user) => (
  canManagePingolfLeague(user)
    ? { to: EVENTS_PATH, label: 'Back to Events' }
    : { to: LEAGUE_PATH, label: 'Back to League' }
);
